import { useMutation } from "@shared/lib/hooks";
import { useCallback } from "react";
import { BRAND_LIST_QUERY_KEY } from "../constants";

import { BrandService } from "../services/brand.service";
import { ToastService } from "@shared/lib/services";
import { ICreateBrand } from "@shared/lib/types";

const QUERY_OPTIONS = {
  queryKey: BRAND_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useCreateBrand() {
  const createBrand = useCallback(
    (brand: ICreateBrand) =>
      BrandService.createBrand(brand).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateBrand>({
    mutationFn: createBrand,
    options: QUERY_OPTIONS,
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
